import { useSearchParams } from 'react-router-dom';

export const useCustomFiltersQueryParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const dynamicParam = searchParams.get('custom') || '';

  return {
    dynamicParam,
    setDynamicParam: (value: string | number) => {
      searchParams.set('custom', String(value));
      // Reset page to 0 when filters change to avoid empty results
      searchParams.set('page', '0');
      setSearchParams(searchParams);
    },
    removeDynamicParam: () => {
      searchParams.delete('custom');
      // Reset page to 0 when filters are cleared
      searchParams.set('page', '0');
      setSearchParams(searchParams);
    },
  };
};
